<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M42 18h-1.94l-2-5.66A2 2 0 0036.2 11H31V9a2 2 0 00-2-2H6a2 2 0 00-2 2v22.5a2 2 0 002 2h4.63a5.5 5.5 0 009.8 0h7.67a5.49 5.49 0 009.79 0H42a2 2 0 002-2V20a2 2 0 00-2-2zM15.51 33.5A2.5 2.5 0 1118 31a2.5 2.5 0 01-2.49 2.5zm17.49 0a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5zm8-3h-2.53a5.5 5.5 0 00-10.95 0H21a5.5 5.5 0 00-11 0H7V10h21v11.5a1.5 1.5 0 003 0V14h4.5l2.44 7H41zM42.5 38h-37a1.5 1.5 0 000 3h37a1.5 1.5 0 000-3z"/></svg>